import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { DeliveryStoresStatusCSVGenerationJobGetPresignedURLResponse } from '@/services/StoreManagement/DeliveryStoresStatusCSVGenerationJob/hooks/getPresignedURL/useDeliveryStoresStatusCSVGenerationJobGetPresignedURL';
import { DeliveryStoresStatusCSVGenerationJobResponse } from '@/services/StoreManagement/DeliveryStoresStatusCSVGenerationJob/hooks/latest/useDeliveryStoresStatusCSVGenerationJobLatest';

interface Interface {
  latest: () => Promise<DeliveryStoresStatusCSVGenerationJobResponse>;
  getPresignedURL: (
    id: string
  ) => Promise<DeliveryStoresStatusCSVGenerationJobGetPresignedURLResponse>;
  create: () => Promise<void>;
}

type EmptyObject = { [key: string]: never };

export class DeliveryStoresStatusCSVGenerationJobService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async create(): Promise<void> {
    return await this.restClient.post<EmptyObject, void>(
      `${TABLET_API_ORIGIN}/dashboard-api/delivery-stores-status-csv-generation-jobs` as const
    );
  }

  public async latest(): Promise<DeliveryStoresStatusCSVGenerationJobResponse> {
    return await this.restClient.get<DeliveryStoresStatusCSVGenerationJobResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/delivery-stores-status-csv-generation-jobs/latest` as const
    );
  }

  public async getPresignedURL(
    id: string
  ): Promise<DeliveryStoresStatusCSVGenerationJobGetPresignedURLResponse> {
    return await this.restClient.get<DeliveryStoresStatusCSVGenerationJobGetPresignedURLResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/delivery-stores-status-csv-generation-jobs/${id}/presigned-url` as const
    );
  }
}
